import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  loading: false,
  shouldLoading: false,
  done: false,
  error: false,
  searchList: [],
  numberOfProducts: 0,
  // measurmentUnit removed - unit is now a simple string field
  brands: [],
  categories: [],
  itemLoading: true,
  itemDetails: {},
  itemFullDetails: null,
  productMerchantDetails: null,
  productMerchantLoading: false,
  deleteModal: false,
  newItem: {
    newPrice: 1,
    newAmount: 1,
    newDiscount: 0,
    newDate: 0,
    itemName: "",
    barCode: "",
    brandName: "Unknown brand",
    brandID: 8083,
    category: 23,
    unit: "pcs", // Changed from measurementUnit to unit (simple string)
    description: "",
    origin: "",
  },
  batchButtonLoading: false,
  updateButtonLoading: false,
  soldButtonLoading: false,
  editItemDetails: {
    acronym: "",
    description: "",
    discount: 0,
    discountPrice: 0,
    expirationDiscount: 0,
    freeOfCostCondition: 0,
    freeofCostAmount: 0,
    images: [],
    internalCode: "",
    itemsSold: 0,
    name: "",
    brandName: "",
    origin: "",
    price: 0,
    productId: 118,
    products: [],
    supplierId: 0,
    supplierProductId: 0,
    unitsInStock: 0,
  },
};

const addItemModalStart = (state, action) => {
  return updateObject(state, { done: false });
};

const addItemStart = (state, action) => {
  return updateObject(state, { loading: true, error: false });
};

const addItemSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    done: true,
    itemLoading: false,
  });
};

const addItemFail = (state, action) => {
  return updateObject(state, {
    loading: false,
    done: true,
    error: true,
    soldButtonLoading: false,
  });
};

const addItemSearchStart = (state, action) => {
  return updateObject(state, { loading: true, shouldLoading: true });
};

const addItemSearchSuccess = (state, action) => {
  // Handle both old and new backend response formats
  const products = action.data.products || action.data || [];
  const count = action.data.numberOfProducts || products.length || 0;
  
  return updateObject(state, {
    loading: false,
    shouldLoading: false,
    searchList: products,
    numberOfProducts: count,
  });
};

const addItemSearchFail = (state, action) => {
  return updateObject(state, { loading: false, shouldLoading: false });
};

const addItemSearchClear = (state, action) => {
  return updateObject(state, {
    searchList: [],
    numberOfProducts: 0,
    loading: false,
    shouldLoading: false,
  });
};

// measurmentUnitSave removed - unit is now a simple string field
const brandsSave = (state, action) => {
  return updateObject(state, { brands: action.data });
};
const categoriesSave = (state, action) => {
  return updateObject(state, { categories: action.data });
};

const getItemStart = (state, action) => {
  return updateObject(state, {
    itemLoading: true,
    done: false,
    soldButtonLoading: false,
  });
};
const getItemSuccess = (state, action) => {
  return updateObject(state, {
    itemLoading: false,
    itemFullDetails: action.itemDetails,
    editItemDetails: action.itemDetails,
  });
};
const getItemFail = (state, action) => {
  return updateObject(state, { itemLoading: false });
};

const updateItemDetails = (state, action) => {
  let newObj = { ...state.editItemDetails };
  newObj[action.name] = action.value;
  return updateObject(state, { editItemDetails: newObj });
};

const deleteItemStart = (state, action) => {
  return updateObject(state, { deleteModal: false });
};

const deleteItemSuccess = (state, action) => {
  return updateObject(state, { deleteModal: true });
};

const addItemUpdateNew = (state, action) => {
  let newObj = { ...state.newItem };
  newObj[action.name] = action.value;
  return updateObject(state, { newItem: newObj });
};

const deleteNewItem = (state, action) => {
  return updateObject(state, {
    newItem: {
      newPrice: 1,
      newAmount: 1,
      newDiscount: 0,
      newDate: 0,
      itemName: "",
      barCode: "",
      brandName: "Unknown brand",
      brandID: 8083,
      category: 23,
      unit: "pcs", // Changed from measurementUnit to unit (simple string)
      description: "",
      origin: "",
    },
  });
};

const addBatchItemStart = (state, action) => {
  return updateObject(state, { batchButtonLoading: true });
};

const addBatchItemSuccess = (state, action) => {
  return updateObject(state, {
    batchButtonLoading: false,
  });
};

const addBatchItemFail = (state, action) => {
  return updateObject(state, { batchButtonLoading: false });
};

const updateFullItem = (state, action) => {
  let newObj = { ...state.itemFullDetails };
  newObj[action.name] = action.value;
  return updateObject(state, { itemFullDetails: newObj });
};

const updatePriceAndDiscountStart = (state, action) => {
  return updateObject(state, { updateButtonLoading: true });
};

const updatePriceAndDiscountSuccess = (state, action) => {
  return updateObject(state, {
    updateButtonLoading: false,
  });
};

const updatePriceAndDiscountFail = (state, action) => {
  return updateObject(state, { updateButtonLoading: false });
};

const putItemStart = (state, action) => {
  return updateObject(state, { soldButtonLoading: true });
};

// New ProductMerchant reducer handlers
const getProductMerchantDetailsStart = (state, action) => {
  return updateObject(state, {
    productMerchantLoading: true,
    done: false,
  });
};

const getProductMerchantDetailsSuccess = (state, action) => {
  return updateObject(state, {
    productMerchantLoading: false,
    productMerchantDetails: action.data,
  });
};

const getProductMerchantDetailsFail = (state, action) => {
  return updateObject(state, { 
    productMerchantLoading: false,
    productMerchantDetails: null,
  });
};

const updateProductMerchantStart = (state, action) => {
  return updateObject(state, { updateButtonLoading: true });
};

const updateProductMerchantSuccess = (state, action) => {
  return updateObject(state, {
    updateButtonLoading: false,
  });
};

const updateProductMerchantFail = (state, action) => {
  return updateObject(state, { updateButtonLoading: false });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_ITEM_MODAL_START:
      return addItemModalStart(state, action);
    case actionTypes.ADD_ITEM_START:
      return addItemStart(state, action);
    case actionTypes.ADD_ITEM_SUCCESS:
      return addItemSuccess(state, action);
    case actionTypes.ADD_ITEM_FAIL:
      return addItemFail(state, action);
    case actionTypes.ADD_ITEM_SEARCH_START:
      return addItemSearchStart(state, action);
    case actionTypes.ADD_ITEM_SEARCH_SUCCESS:
      return addItemSearchSuccess(state, action);
    case actionTypes.ADD_ITEM_SEARCH_FAIL:
      return addItemSearchFail(state, action);
    case actionTypes.ADD_ITEM_SEARCH_CLEAR:
      return addItemSearchClear(state, action);
    // ADD_ITEM_MEASURMENT_UNIT case removed - unit is now a simple string field
    case actionTypes.ADD_ITEM_BRAND:
      return brandsSave(state, action);
    case actionTypes.ADD_ITEM_CATEGORIES:
      return categoriesSave(state, action);
    case actionTypes.GET_ITEM_START:
      return getItemStart(state, action);
    case actionTypes.GET_ITEM_SUCCESS:
      return getItemSuccess(state, action);
    case actionTypes.GET_ITEM_FAIL:
      return getItemFail(state, action);
    case actionTypes.ITEM_DETAILS_UPDATE:
      return updateItemDetails(state, action);
    case actionTypes.DELETE_ITEM_START:
      return deleteItemStart(state, action);
    case actionTypes.DELETE_ITEM_SUCCESS:
      return deleteItemSuccess(state, action);
    case actionTypes.DELETE_ITEM_FAIL:
      return deleteItemSuccess(state, action);
    case actionTypes.ADD_ITEM_UPDATE_NEW_ITEM:
      return addItemUpdateNew(state, action);
    case actionTypes.ADD_ITEM_DELETE_NEW_ITEM:
      return deleteNewItem(state, action);
    case actionTypes.ADD_BATCH_ITEM_START:
      return addBatchItemStart(state, action);
    case actionTypes.ADD_BATCH_ITEM_SUCCESS:
      return addBatchItemSuccess(state, action);
    case actionTypes.ADD_BATCH_ITEM_FAIL:
      return addBatchItemFail(state, action);
    case actionTypes.ITEM_FULL_DETAILS_UPDATE:
      return updateFullItem(state, action);
    case actionTypes.UPDATE_PRICE_DISCOUNT_START:
      return updatePriceAndDiscountStart(state, action);
    case actionTypes.UPDATE_PRICE_DISCOUNT_SUCCESS:
      return updatePriceAndDiscountSuccess(state, action);
    case actionTypes.UPDATE_PRICE_DISCOUNT_FAIL:
      return updatePriceAndDiscountFail(state, action);
    case actionTypes.PUT_ITEM_START:
      return putItemStart(state, action);
    // New ProductMerchant action handlers
    case actionTypes.GET_PRODUCT_MERCHANT_DETAILS_START:
      return getProductMerchantDetailsStart(state, action);
    case actionTypes.GET_PRODUCT_MERCHANT_DETAILS_SUCCESS:
      return getProductMerchantDetailsSuccess(state, action);
    case actionTypes.GET_PRODUCT_MERCHANT_DETAILS_FAIL:
      return getProductMerchantDetailsFail(state, action);
    case actionTypes.UPDATE_PRODUCT_MERCHANT_START:
      return updateProductMerchantStart(state, action);
    case actionTypes.UPDATE_PRODUCT_MERCHANT_SUCCESS:
      return updateProductMerchantSuccess(state, action);
    case actionTypes.UPDATE_PRODUCT_MERCHANT_FAIL:
      return updateProductMerchantFail(state, action);
    default:
      return state;
  }
};

export default reducer;
